<p-contextMenu #cm [model]="items" styleClass="p-contextmenu-custom" (onHide)="onHide()" (onShow)="onShow()">
  <ng-template #item let-item>
    <a pRipple>
      <div class="contextmenu-item-icon">
        <mat-icon>{{item.icon}}</mat-icon>
      </div>

      <span class="contextmenu-item-label">{{ item.label }}</span>

      @if (item.badge) {
      <p-badge class="ms-auto" [value]="item.badge" />
      }

      <!--  -->

      @if (item.shortcut) {
      <span class="ms-auto border border-surface rounded bg-emphasis text-muted-color text-xs p-1">
        {{ item.shortcut }}
      </span>
      }

      <!--  -->

      @if (item.items) {
      <i class="pi pi-angle-right ms-auto rotate-90 lg:rotate-0"></i>
      }
    </a>
  </ng-template>
</p-contextMenu>
